enum MountingTypeCode {
    S_CLAY_FOOT = "s_clay_foot",
    S_CLAY_TILE = "s_clay_tile",
    S_CONCRETE_BRACKET = "s_concrete_bracket",
    S_CONCRETE_FOOT = "s_concrete_foot",
    S_CONCRETE_TILE = "s_concrete_tile",
    S_FELT_ROOF = "s_felt_roof",
    S_FOLDED = "s_folded",
    S_LOAD_BEARING = "s_load_bearing",
    S_MODULAR = "s_modular",
    S_PROFILED_METAL = "s_profiled_metal",
    S_PROFILED_SHEET = "s_profiled_sheet",
    S_SOFFIT = "s_soffit",
    S_STANDING_SEAM = "s_standing_seam",
    S_TILE_SHEET = "s_tile_sheet",
    S_TINSMITH_SEAM = "s_tinsmith_seam",
    S_WALL_PROFILE = "s_wall_profile",
    S_WATERPROOFING = "s_waterproofing",
    S_RCT_RSP_PROFILEDROPDOWN = "s_rct_rsp_profiledropdown",
    S_FLAT_ROOF = "s_flat_roof",
    S_NONE = "s_none",
};

export { MountingTypeCode }
